/** Max size for SFTP SSH private key file upload in AddWorkflowStepPopup (Story 1.3). */
export const SFTP_SSH_PRIVATE_KEY_FILE_MAX_BYTES = 512 * 1024;

export function getSftpPrivateKeyFileTooLargeMessage(fileSize: number): string | null {
  if (fileSize <= SFTP_SSH_PRIVATE_KEY_FILE_MAX_BYTES) {
    return null;
  }
  return `Key file is too large (${fileSize} bytes). Maximum allowed is ${SFTP_SSH_PRIVATE_KEY_FILE_MAX_BYTES} bytes.`;
}
